export default __webpack_public_path__ + "static/media/sg90@3x.029a861c.webp";